(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    class ContactFormComponent extends HTMLElement {
    connectedCallback() {
      const form = this.querySelector('form');
      if (!form) return;

      const params = new URLSearchParams(window.location.search);
      if (params.get('customer_posted') === 'true' ||
          params.get('contact_posted') === 'true') {
        this.showSuccess();
        return;
      }

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.handleSubmit(form);
      });
    }

    async handleSubmit(form) {
      try {
        const response = await fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          headers: { 'Accept': 'text/html' }
        });

        if (response.ok) {
          this.showSuccess();
        } else {
          form.submit();
        }
      } catch (e) {
        form.submit();
      }
    }

    showSuccess() {
      const successMessage = this.querySelector('.contact-form__success');
      const formFields = this.querySelector('.contact-form__fields');
      const successHeading = this.querySelector('.contact-form__success-heading');

      if (!successMessage || !formFields) return;

      formFields.hidden = true;
      successMessage.hidden = false;

      requestAnimationFrame(() => {
        if (successHeading) {
          successHeading.focus();
          successHeading.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }
  }

  customElements.define('contact-form-component', ContactFormComponent);
  } catch(e) { console.error(e); }
})();

})();
